import React from 'react';
import { StatChip } from '../ui/StatChip';
export function RoiStats() {
  const stats = [{
    value: '+24%',
    label: 'Employee NPS'
  }, {
    value: '3×',
    label: 'Idea Velocity'
  }, {
    value: '97%',
    label: '"Best Retreat Ever"'
  }];
  return <section className="py-16 bg-[#0099A1]" data-id="element-204">
      <div className="container mx-auto px-4 md:px-6" data-id="element-205">
        <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-206">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-207">
            Signature ROI
          </h2>
          <p className="text-lg text-white/80" data-id="element-208">
            Our retreats deliver measurable business impact that transforms your
            team and bottom line.
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-6" data-id="element-209">
          {stats.map((stat, index) => <StatChip key={index} value={stat.value} label={stat.label} className="transform hover:-translate-y-1 transition-transform" data-id="element-210" />)}
        </div>
      </div>
    </section>;
}